export default "__VITE_ASSET__CkGeaVz3__"